import { createStore } from 'vuex'

export default createStore({
  state: {
    brandConfig: undefined,
    showWinDailyBanner: true,
    acquisitionConfig: undefined,
    currencyAmount: undefined,
    campaignId: undefined,
    trackerId: undefined,
    publisherId: undefined
  },
  mutations: {
    setShowWinDailyBanner(state, showWinDailyBanner) {
      state.showWinDailyBanner = showWinDailyBanner
    },
    setAcquisitionConfig(state, acquisitionConfig) {
      state.acquisitionConfig = acquisitionConfig
    },
    setCurrencyAmount(state, currencyAmount) {
      state.currencyAmount = currencyAmount
    },
    setCampaignId(state, campaignId) {
      state.campaignId = campaignId
    },
    setTrackerId(state, trackerId) {
      state.trackerId = trackerId
    },
    setPublisher(state, publisherId) {
      state.publisherId = publisherId
    }
  },
  actions: {
  },
  modules: {
  }
})
